import React from 'react';
import ReactDOM from 'react-dom';
import ClickAndCollectCountdown from './components/Countdown/Countdown';

let clickAndCollectCountdownDiv;

export const unmount = () => {
  if (!clickAndCollectCountdownDiv) {
    return;
  }

  ReactDOM.unmountComponentAtNode(clickAndCollectCountdownDiv);
}

export default () => {
  try {
    clickAndCollectCountdownDiv = document.getElementById('click-and-collect-countdown');

    if (!clickAndCollectCountdownDiv) {
      return;
    }

    if (window.jlData && window.jlData.page.locale.country !== 'uk') {
      return;
    }

    const {
      dataset: {
        countdownEnabled,
        futureRelease,
        cutOffTime,
        skuSelected,
        anyInStock,
        skuInStock,
        collectTime,
      }
    } = clickAndCollectCountdownDiv;

    if (
      countdownEnabled === "false" ||
      futureRelease === "true" ||
      (skuSelected === "true" && skuInStock === "false") ||
      anyInStock === "false"
    ) {
      return;
    }

    return ReactDOM.render(
      <ClickAndCollectCountdown cutOffTime={cutOffTime} collectTime={collectTime}/>,
      clickAndCollectCountdownDiv,
    );
  } catch (e) {
    console.error(e);
  }
};
